'use client';
import IconClose from '@/assets/icons/icon-round-close.svg';
import DefaultImageProduct from '@/assets/images/defaultProduct.png';
import { Link, useRouter } from '@/i18n/navigation';
import useAuthModal from '@/zustand/useAuthModal';
import useUserStore from '@/zustand/useUser';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { useWindowSize } from 'react-use';
import { Button } from 'rsuite';
import ShoppingCartModal from '../shopping-cart-modal';
import CardsCarousel from './components/products-carousel';
import TabsCarousel from './components/tabsCarousel';
import styles from './shopping.module.scss';
import { useTranslations } from 'next-intl';

const ShoppingCartContent = ({
  orderLine,
  similarProducts,
  handleCartClose,
}: any) => {
  const [tab, setTab] = useState(similarProducts?.[0]?.category?.id);
  const [open, setOpen] = useState(false);
  const { width } = useWindowSize();
  const route = useRouter();
  const userData = useUserStore((user: any) => user?.user);
  const isLoggedIn = Boolean(userData?.id);
  const { isPopoverOpen, setPopoverOpen } = useAuthModal();
  const triggerRef = useRef<any>();
  const t = useTranslations('Components.shopping-card-content');

  const handleClose = () => {
    setOpen(false);
    handleCartClose();
  };

  const handleNavigateOrder = () => {
    if (isLoggedIn) {
      route.push('/order');
      handleCartClose();
    } else {
      triggerRef.current?.open?.();
      setPopoverOpen(true);
    }
  };

  const filteredProducts = similarProducts?.filter(
    (item: any) => item?.category?.id === tab
  );

  // const combinedProducts =
  //   filteredProducts
  //     ?.flatMap((item: any) => item?.similarProducts || [])
  //     .flatMap((product: any) =>
  //       product?.edges?.map((edge: any) => edge?.node)
  //     ) || [];

  useEffect(() => {
    if (similarProducts?.length > 0 && !tab) {
      setTab(similarProducts?.[0]?.category?.id);
    }
  }, []);

  return (
    <div className={styles.cartContentWrapper}>
      <div className={styles.topSection}>
        <div className={styles.header}>
          <h3>{t('product-added-to-cart')}</h3>
          <div className={styles.closeBtn} onClick={handleCartClose}>
            <IconClose />
          </div>
        </div>
        <div className={styles.product}>
          <div className={styles.item}>
            <div style={{ maxWidth: '90px' }}>
              <Image
                width={80}
                height={70}
                src={orderLine?.thumbnail?.url || DefaultImageProduct}
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
                alt="product image"
              />
            </div>
            <h4 className={styles.productTitle}>{orderLine?.variantName}</h4>
          </div>
          <div className={styles.btnGroup}>
            {width >= 991 ? (
              <Button
                onClick={() => route.push('/cart')}
                className={styles.linkCart}
              >
                {t('go-to-cart')}
              </Button>
            ) : (
              <Link
                href={'/cart'}
                onClick={handleCartClose}
                className={styles.linkCart}
              >
                {t('go-to-cart')}
              </Link>
            )}
            <Button onClick={handleCartClose} className={styles.btnBuy}>
              {t('continue-shopping')}
            </Button>
          </div>
        </div>
        {similarProducts?.length > 0 && (
          <div className={styles.tabsWrapper}>
            <h3 className={styles.tabsTitle}>{t('add-to-purchase')}</h3>
            <div className={styles.tabs}>
              <TabsCarousel
                similarProducts={similarProducts}
                tab={tab}
                setTab={setTab}
              />
            </div>
          </div>
        )}
      </div>
      {similarProducts?.length > 0 && (
        <div className={styles.bottomSection}>
          <CardsCarousel combinedProducts={filteredProducts} />
        </div>
      )}
      <div className={styles.orderButton}>
        <Button
          type="button"
          className={styles.btn}
          onClick={handleNavigateOrder}
        >
          {t('formalize-one-click')}
        </Button>
      </div>
      {open && <ShoppingCartModal open={open} handleClose={handleClose} />}
    </div>
  );
};

export default ShoppingCartContent;
